import React, { useState, useEffect } from "react";
import { UIButton, UIText } from "src/components/uIKit"; // Assuming you have a separate UIText component

import styles from "./styles.module.scss";
import Loader from "../loader/Loader";
import { useIsMobile } from "src/hooks/useIsMobile";
import { Button } from "antd";

interface UserInfoBannerProps {
  title: string;
  subTitle: string;
  editText?: string;
  icon: string;
  iconStyle?: string;
  ariaLabel?: string;
  onEdit?: (value: string) => void;
  onBlur?: (value: string) => void;
}

const UserInfoBanner: React.FC<UserInfoBannerProps> = ({
  title,
  subTitle,
  editText,
  ariaLabel,
  icon,
  iconStyle,
  onEdit,
  onBlur,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const isMobile = useIsMobile();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const handleInputChange = (value: string) => {
    onEdit?.(value);
  };

  const handleInputBlur = () => {
    setIsEditing(false);
    onBlur?.(title);
  };

  return (
    <div className={styles.phoneWrapper}>
      <div className={styles.iconWrapper}>
        <img src={icon} alt="" className={iconStyle} />
      </div>
      <div className={styles.flex1}>
        {(isEditing || title) && (
          <div>
            {isEditing ? (
              <input
                type="text"
                value={title}
                className={styles.phoneTitle}
                style={{
                  fontSize: "18px",
                  fontWeight: 400,
                  border: "none",
                  background: "transparent",
                  width: "100%",
                }}
                onChange={(e) => handleInputChange(e.target.value)}
                onBlur={handleInputBlur}
                autoFocus
              />
            ) : isMobile && editText ? (
              <Button
                // text={title}
                className={styles.phoneTitleButton}
                onClick={handleEditClick}
              >
                <UIText
                  text={title}
                  size={18}
                  weight={400}
                  style={styles.phoneTitle}
                />
              </Button>
            ) : (
              <UIText
                text={title}
                size={18}
                weight={400}
                style={styles.phoneTitle}
              />
            )}
          </div>
        )}

        {showLoader && (
          <div className={styles.loaderWrapper}>
            <span className={styles.loader}></span>
          </div>
        )}
        <UIText
          text={subTitle}
          size={15}
          weight={400}
          style={styles.phoneSubTitle}
        />
      </div>
      {editText && !isMobile && !showLoader ? (
        <UIButton
          tabIndex={0}
          title={editText}
          ariaLabel={ariaLabel}
          textStyle={styles.textEdit}
          style={styles.edit}
          onSubmit={handleEditClick}
        />
      ) : null}
    </div>
  );
};

export default UserInfoBanner;
